import { useEffect, useRef } from 'react';

interface IInlineSvgIcon {
  svg: string;
  className?: string;
}

export default function InlineSvgIcon({ svg, className }: IInlineSvgIcon) {
  const containerRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const parser = new DOMParser();
    const doc = parser.parseFromString(svg, 'image/svg+xml');
    const svgEl = doc.querySelector('svg');

    if (!svgEl) return;

    svgEl.removeAttribute('fill');
    svgEl.removeAttribute('stroke');
    svgEl.removeAttribute('style');

    svgEl.querySelectorAll('*').forEach((el) => {
      el.removeAttribute('fill');
      el.removeAttribute('stroke');
      el.removeAttribute('style');
    });

    if (className) {
      className.split(' ').forEach((cls) => {
        if (cls) svgEl.classList.add(cls);
      });
    }

    containerRef.current.innerHTML = '';
    containerRef.current.appendChild(svgEl);
  }, [svg, className]);

  return <span ref={containerRef} />;
}
